import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addCategory } from '../../../api/redux/slices/Admin';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToast } from '../../../components/modal';

const AddCategory = ({ addModalOpen, setAddModalOpen }) => {
	const dispatch = useDispatch();
	const [isFocus, setIsFocus] = useState(false);
	const token = localStorage.getItem('accesstoken');

	const [values, setValues] = useState({
		description: '',
		designation: '',
	});

	const handleAdd = (e) => {
		e.preventDefault();
		const data = {
			designation: values.designation.trim(),
			description: values.description.trim(),
		};
		if (!data.description || !data.designation) {
			showToast('Veuillez remplir tous les champs', 'warn');
			return;
		}
		dispatch(addCategory({ token: token, data }))
			.unwrap()
			.then(() => {
				setValues({ designation: '', description: '' });
				toast.success('Catégorie ajouté', {
					position: 'top-center',
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				});
				setAddModalOpen(false);
			})
			.catch((err) => {
				toast.error(err.error, {
					position: 'top-center',
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				});
			});
	};

	return (
		<div className={'modalcontainer ' + (addModalOpen && 'open')}>
			<div className={'modal ' + (addModalOpen && 'active')}>
				<h1>Ajouter une nouvelle catégorie</h1>
				<form onSubmit={handleAdd}>
					<div className='label-input'>
						<label>Nom de catégorie</label>
						<input
							type='text'
							placeholder='Nom'
							value={values.designation}
							onChange={(e) => {
								setValues({ ...values, designation: e.target.value });
								setIsFocus(true);
							}}
							required
						/>
					</div>
					<div className='desc-modal'>
						<label>Description</label>
						<textarea
							name='description'
							cols='3'
							rows='5'
							placeholder='Description'
							value={values.description}
							onChange={(e) => {
								setValues({ ...values, description: e.target.value });
								setIsFocus(true);
							}}
							required
						/>
					</div>
					<div className='submit-btns'>
						<div className='add-btns'>
							<button
								className={isFocus ? 'button-nature' : 'button-nature-inactive'}
								onClick={(e) => {
									e.preventDefault();
									setAddModalOpen(false);
								}}
							>
								Annuler
							</button>
							<button
								className={isFocus ? 'button-primary' : 'button-primary-inactive'}
								type='submit'
							>
								Ajouter
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	);
};

export default AddCategory;
